import { Button } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const RemoveButton = styled(Button)``;
const RemoveContent = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export { RemoveButton, RemoveContent };
